var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Modal",
        {
          attrs: {
            width: 1300,
            "footer-hide": true,
            title: "定单明细",
            draggable: "",
          },
          on: { "on-visible-change": _vm.onShowChange },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _vm.innerSpin
            ? _c("Spin", { attrs: { size: "large", fix: "" } })
            : _vm._e(),
          _c(
            "Card",
            { attrs: { padding: 0, bordered: false, "dis-hover": true } },
            [
              _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c(
                        "Form",
                        {
                          staticClass: "form-input-no-outline",
                          attrs: { "label-position": "top" },
                        },
                        [
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单编号" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordCode,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "发货日期" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateString(
                                            _vm.orderRecord
                                              .preSaleOrderRecordSendProductDate
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "4" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "下单时间" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value: _vm.formatDateTimeString(
                                            _vm.orderRecord
                                              .preSaleOrderRecordCreateAt
                                          ),
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "定单状态" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordOrderStatus,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "客户名称" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressContacts,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "3" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "联系电话" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .deliveryAddressPhone,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "5" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "收货地址" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord.deliveryAddressFull,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "总件数" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordTotalPieces,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "总体积" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordTotalVolume,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "总配送费" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordStationDeliveryFee,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "Col",
                                { attrs: { span: "2" } },
                                [
                                  _c(
                                    "FormItem",
                                    { attrs: { label: "总包装费" } },
                                    [
                                      _c("Input", {
                                        attrs: {
                                          value:
                                            _vm.orderRecord
                                              .preSaleOrderRecordTotalPackageFee,
                                          readonly: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "Row",
                            { attrs: { gutter: 16 } },
                            [
                              _c(
                                "Col",
                                { attrs: { span: "24" } },
                                [
                                  _c(
                                    "FormItem",
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_c("b", [_vm._v("定单商品")])]
                                      ),
                                      _c("Table", {
                                        ref: "mainTable",
                                        attrs: {
                                          size: "small",
                                          columns: _vm.orderDetail.columns,
                                          data: _vm.orderDetail.rows,
                                          stripe: "",
                                          border: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("PreSaleOrderDelivery", { ref: "preSaleOrderDeliveryModal" }),
      _vm.orderRecord.preSaleOrderRecordCodeOld
        ? _c("PreSaleOrderDetail", { ref: "preSaleOrderDetail" })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }